import { flex } from '@/styles/minix';
import styled from 'styled-components';
export const ForgetForm = styled.div`
	.ant-form {
		padding: 0 28px;
		.dubble-item {
			${flex('row', 'space-between', 'center')};
			.twice-btn {
				position: relative;
				width: 100px;
				margin-left: 10px;
				border-radius: 4px;
			}
			.ant-btn {
				min-width: 100px;
			}
		}

		.ant-form-item-label
			> label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
			content: '';
		}
		.ant-form-item-explain {
			display: none;
		}
		.ant-form-item-label {
			text-align: right;
		}
	}
`;

export const UserInputWrap = styled.div`
	.ant-input-group.ant-input-group-compact {
		${flex('row', '', '')}
	}
`;
